export default __webpack_public_path__ + "static/media/266.278a5fef.png";